import { TGetProductContractListResDto } from "@/api/services/admin/organization/dtos/get-organization-detail.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { EContractStatus } from "@/types/enum";
import { clientApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useQuery } from "@tanstack/react-query";

export type TGetProductContractListReqDto = {
  sorts?: string[];
  includeCenter?: boolean;
  includeContractStatuses?: EContractStatus[];
};

export const fetchProductContractsByOrganizationApi = async (
  organizationId: string,
  params?: TGetProductContractListReqDto,
): Promise<TGetProductContractListResDto> => {
  const url = createUrlWithParams(`/product-contracts/organizations/${organizationId}`, params);
  const rs = await clientApi.get<TGetProductContractListResDto>(url);
  return rs.data;
};

export const useProductContractsByOrganization = (organizationId?: string, params?: TGetProductContractListReqDto) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PRODUCT_CONTRACT.FETCH_LIST_BY_ORGANIZATION, organizationId, params],
    queryFn: () => fetchProductContractsByOrganizationApi(organizationId!, params),
    enabled: Boolean(organizationId),
  });
};
